const ConsoleHelper = (data, context) => {
    if (process.env.NODE_ENV === 'production') return;
    if (context) {
        console.log(data, context);
        return;
    }
    console.log(data);
}

export default ConsoleHelper;